const applyTruncateStyles = (el, maxHeight) => {
  el.style.maxHeight = `${maxHeight}px`
  el.style.overflow = 'hidden'
  el.style.position = 'relative'
}

const removeTruncateStyles = (el) => {
  el.style.cssText = el.dataset.cssText
}

const addGradientElement = (el, tag) => {
  const grandientEl = document.createElement('span')
  grandientEl.dataset.tag = tag
  grandientEl.style.position = 'absolute'
  grandientEl.style.bottom = 0
  grandientEl.style.left = 0
  grandientEl.style.right = 0
  grandientEl.style.position = 'absolute'
  grandientEl.style['background-image'] = 'linear-gradient(to bottom, transparent, white)'
  grandientEl.style['padding-bottom'] = '45px'
  grandientEl.style['z-index'] = 1
  el.append(grandientEl)
}

const removeGradientElement = (el, tag) => {
  const grandientEl = el.querySelector(`[data-tag="${tag}"]`)
  if (grandientEl) {
    grandientEl.remove()
  }
}

const BCTruncateText = {

  bind (el) {
    el.dataset.cssText = el.style.cssText
  },

  componentUpdated (el, {value}, vnode) {
    const isActive = value.isActive === undefined ? true : value.isActive
    const maxHeight = value.maxHeight || 170
    const tag = vnode.componentInstance._uid
    const isOverMaxHeight = el.clientHeight > maxHeight

    if (!isActive) {
      removeTruncateStyles(el)
      removeGradientElement(el, tag)
      return
    }

    if (isOverMaxHeight) {
      applyTruncateStyles(el, maxHeight)
      addGradientElement(el, tag)
      const event = new CustomEvent('text-truncated', {bubbles: true})
      el.dispatchEvent(event)
    }
  }
}

export default BCTruncateText
